import type { LegacyHtmlText } from 'types/capi/content';

type Props = {
  item: LegacyHtmlText;
};

const LegacyHtml = ({ item }: Props) => {
  return (
    <span
      data-cy="legacy-html"
      dangerouslySetInnerHTML={{ __html: item.html }}
      className="[&>p]:my-10"
    />
  );
};
export default LegacyHtml;
